renderPosts();

function renderPosts() {
	if (postPage > 1 && paginationNumbersArr > 3) {
		createPaginationNumber("...");
	}
	for (let i = 0; i < paginationNumbersArr; i++) {
		if (postPage > paginationNumbersArr - 3) {
			if (i < paginationNumbersArr - 3) {
				void 0;
			} else {
				createPaginationNumber(i + 1);
			}
		} else {
			if (i > postPage + 1) {
				createPaginationNumber("...");
				break;
			} else if (i < postPage - 1) {
				void 0;
			} else {
				createPaginationNumber(i + 1);
			}
		}
	}
}

function createPaginationNumber(string) {
	let pgNums = document.querySelector("#pagination-numbers");
	let newItem = document.createElement("a");
	newItem.textContent = string;
	newItem.style.cursor = "pointer";
	newItem.onclick = function (event) {
		if (string !== "...") {
			postPage = Number(string);
			displayCards(limit);
			removeAllNumbers();
			renderPosts();
			$("html, body").animate({scrollTop: 0}, 1000);
		}
	};

	if (string == String(postPage)) {
		newItem.className = "pagination__link pagination--active";
		pgNums.appendChild(newItem);
	} else {
		newItem.className = "pagination__link";
		pgNums.appendChild(newItem);
	}
}

function removeAllNumbers() {
	let pgNums = document.querySelector("#pagination-numbers");
	try {
		while (pgNums.firstChild) {
			pgNums.removeChild(pgNums.firstChild);
		}
	} catch (err) {}
}
